export const fieldsName = {
  shopifyStore: 'shopifyStore',
  shopifyOrderId: 'shopifyOrderId',
};
